import React from "react";
import ChartistGraph from "react-chartist";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Label } from "reactstrap";
import { getAllTotalAreaManager } from "stores";
import { getAllTotalPengajuan } from "stores";
import ReactDatetime from "react-datetime";
import { getTotalPencairan } from "stores/dashboardUtama/function";
import { getGrafikPencairanCabang } from "stores";
import moment from "moment";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLabel,
  VictoryLegend,
  VictoryTheme,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from "victory";
import { getTotalTargetUser } from "stores/Pengajuan/function";
import { getGrafikPencairanUser } from "stores";
import { getAllTotalSupervisor } from "stores";
import { getAllTotalMarketing } from "stores";
import { getAllTotalCabang } from "stores";
import { getExportPengajuan } from "stores";
import "assets/img/logo-sulutgo.png";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getAllWilayah } from "stores";
import SplitText from "./SplitText";

function DashboardUtama() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const dashboard = useSelector((state) => state.pengajuanReducer);
  // const cardTotalPencairan = useSelector((state) => state.pengajuanReducer);
  const cardTotalPengajuan = useSelector(
    (state) => state.dashboardUtamaReducer,
  );

  const tampilTotalPengajuan = useSelector(
    (state) => state.dashboardUtamaReducer.totalAllPengajuan,
  );

  const [modalMenunggu, setModalMenunggu] = React.useState(false);
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [modalDitolak, setModalDitolak] = React.useState(false);
  const [modalDisetujui, setModalDisetujui] = React.useState(false);
  const [modalDiproses, setModalDiproses] = React.useState(false);

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const totalTarget = hasilPresentase > 100;
  const [totalNominalPencairan, setTotalNominalPencairan] = React.useState(0);
  const [listWilayah, setListWilayah] = React.useState([]);
  const [idWilayah, setIdWilayah] = React.useState({
    label: "All",
    value: "",
  });

  const [hasilPresentase, setHasilPresentase] = React.useState(0);
  const [totalNominalTarget, setTotalNominalTarget] = React.useState(0);
  const [dataGrafikCabang, setDataGrafikCabang] = React.useState([]);
  const [dataGrafikUser, setDataGrafikUser] = React.useState([]);
  const [totalSpv, setTotalSpv] = React.useState([]);
  const [totalCbg, setTotalCbg] = React.useState([]);
  const [totalAM, setTotalAM] = React.useState([]);
  const [totalMarketing, setTotalMarketing] = React.useState([]);
  const [dataAllGrafikCabang, setDataAllGrafikCabang] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [tglAwal, setTglAwal] = React.useState("");
  const [tglAkhir, setTglAkhir] = React.useState("");
  const [modalExport, setModalExport] = React.useState(false);
  const [dariTgl, setDariTgl] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [modalDetail, setModalDetail] = React.useState(false);
  const [smpTgl, setSmpTgl] = React.useState(new Date());
  const pencairanData = dataGrafikCabang.map((item) => item.totalPencairan);
  const targetData = dataGrafikCabang.map((item) => item.totalTarget);
  const [tahun, setTahun] = React.useState(new Date().getFullYear());
  let yearNow = new Date().getFullYear();
  const [listYear, setListYear] = React.useState([]);
  const bulanData = dataGrafikUser.map((item) => item.bulan);

  const pencairanDataUser = dataGrafikUser.map(
    (item) => item.totalNominalPencairan,
  );

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const targetDataUser = dataGrafikUser.map((item) => item.totalNominalTarget);
  const abjadCabang = dataGrafikCabang.map((_, index) =>
    String.fromCharCode(65 + index),
  );

  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const options =
    auth.role === "super admin"
      ? [{ value: "", label: "All" }, ...listWilayah]
      : listWilayah;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const closeModal = () => {
    setCurrentPage(1);
    setModalDetail(false);
    setModalMenunggu(false);
    setModalRevisi(false);
    setModalDiproses(false);
    setModalDisetujui(false);
    setModalDitolak(false);
  };

  const chartData = {
    labels: abjadCabang,
    series: [pencairanData, targetData],
  };

  const chartDataUser = {
    labels: bulanData,
    series: [pencairanDataUser, targetDataUser],
  };

  const handleExportPengajuan = () => {
    setStatus("");
    setTglAwal("");
    setTglAkhir("");
  };

  const submitExport = (e) => {
    e.preventDefault();
    // console.log(tglAwal, tglAkhir, status.value, "ASLKASDASDSAD");
    // if (status === "") {
    //   Swal.fire({
    //     title: "Status Harus Diisi",
    //     icon: "warning",
    //   });
    //   return;
    // }
    getExportPengajuan({
      tglAwal: tglAwal,
      tglAkhir: tglAkhir,
      statusPengajuan: status.value,
    });
  };

  React.useEffect(() => {
    // setIsVisible(true);s
    getListYear();
  }, []);

  React.useEffect(() => {
    getAllTotalPengajuan(dispatch, { idWilayah: idWilayah.value });
  }, [idWilayah]);

  const getListYear = () => {
    let tmp = [];
    for (let i = 5; i >= 0; i--) {
      let years = yearNow--;
      tmp.push({
        value: years,
        label: years,
      });
    }
    setListYear(tmp);
  };

  React.useEffect(() => {
    getTotalPencairan(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
      idWilayah: idWilayah.value,
    }).then((response) => {
      // console.log(response, "PPPP");
      const totalPencairan = response.data.totalNominal;
      setTotalNominalPencairan(totalPencairan);
    });
  }, [dariTgl, smpTgl, idWilayah]);

  React.useEffect(() => {
    getTotalTargetUser(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
      idWilayah: idWilayah.value,
    }).then((response) => {
      const totalTarget = response.data.totalTarget;
      setTotalNominalTarget(totalTarget);
    });
  }, [dariTgl, smpTgl, idWilayah]);

  React.useEffect(() => {
    getGrafikPencairanCabang(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
      idWilayah: idWilayah.value,
    }).then((response) => {
      const grafikCabang = response.data;
      let tmp = [];
      grafikCabang.map((val, index) => {
        if (index < 15) {
          tmp.push(val);
        }
      });
      setDataGrafikCabang(tmp);
      setDataAllGrafikCabang(grafikCabang);
    });
  }, [dariTgl, smpTgl, idWilayah]);

  React.useEffect(() => {
    getGrafikPencairanUser(dispatch, {
      tahun: tahun,
      idWilayah: idWilayah.value,
    }).then((response) => {
      const grafikUser = response.data;
      // console.log(grafikUser, "GRAFIK");
      setDataGrafikUser(grafikUser);
    });
  }, [tahun, idWilayah]);

  React.useEffect(() => {
    if (totalNominalPencairan !== 0 && totalNominalTarget !== 0) {
      const presentase = Math.round(
        (totalNominalPencairan / totalNominalTarget) * 100,
      );
      setHasilPresentase(presentase);
    } else {
      setHasilPresentase(0);
    }
  }, [totalNominalPencairan, totalNominalTarget]);

  React.useEffect(() => {
    getAllTotalSupervisor(dispatch, { idWilayah: idWilayah.value }).then(
      (response) => {
        const dataSupervisor = response.data;
        setTotalSpv(dataSupervisor);
      },
    );
  }, [idWilayah]);

  React.useEffect(() => {
    getAllTotalAreaManager(dispatch, { idWilayah: idWilayah.value }).then(
      (response) => {
        const dataAreaManager = response.data;
        setTotalAM(dataAreaManager);
      },
    );
  }, [idWilayah]);

  React.useEffect(() => {
    getAllTotalMarketing(dispatch, { idWilayah: idWilayah.value }).then(
      (response) => {
        const dataMarketing = response.data;
        setTotalMarketing(dataMarketing);
      },
    );
  }, [idWilayah]);

  React.useEffect(() => {
    getAllTotalCabang(dispatch, { idWilayah: idWilayah.value }).then(
      (response) => {
        // console.log(response, "CABANG");
        const dataCabang = response.data;
        setTotalCbg(dataCabang);
      },
    );
  }, [idWilayah]);

  const customStyles = {
    rows: {
      style: {
        height: 70, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        //fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const colCabangPencairan = [
    {
      name: "No",
      width: "70px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama Cabang",
      minWidth: "150px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Total Pencairan",
      minWidth: "200px",
      center: true,
      selector: (row) => formatRupiah(row.totalPencairan),
    },
    {
      name: "Total Target",
      minWidth: "200px",
      center: true,
      selector: (row) => formatRupiah(row.totalTarget),
    },
    {
      name: "Total Nasabah",
      minWidth: "120px",
      center: true,
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      selector: (row) => row.totalNasabah,
    },
  ];

  React.useEffect(() => {
    let tmp = [{ value: "", label: "All" }];
    cardTotalPengajuan.allWilayah &&
      cardTotalPengajuan.allWilayah.map((val) => {
        // console.log(val, "VAL WILAYAH");
        tmp.push({
          value: val._id,
          label: val.namaWilayah,
        });
      });
    setListWilayah(tmp);
    let Obj = cardTotalPengajuan.allWilayah.find(
      (x) => x.namaWilayah === "Gorontalo",
    );
    // setIdWilayah({ value: Obj._id, label: Obj.namaWilayah });
    // console.log(Obj, ">>>>>>>>>>>>>>>>");
  }, [cardTotalPengajuan.allWilayah]);

  React.useEffect(() => {
    getAllWilayah(dispatch).then((response) => {
      // const dataCabang = response.data;
      // setTotalCbg(dataCabang);
    });
  }, []);

  React.useEffect(() => {
    if (auth.role === "client") {
      const interval = setInterval(() => {
        window.location.reload();
        refresh();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [auth.role]);
  // console.log(idWilayah, "?????????????????????");
  return (
    <>
      <Modal
        size="lg"
        show={modalDetail}
        onHide={closeModal}
        // onHide={() => setModalDetail(!modalDetail)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Detail Data Cabang Pencairan
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body style={{ marginTop: 20 }}>
              <DataTable
                columns={colCabangPencairan}
                data={dataAllGrafikCabang}
                // .filter(
                //   (row) =>
                //     row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                //     row.nopeg.toLowerCase().includes(searchText.toLowerCase())
                // )}
                customStyles={customStyles}
                pagination
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
              />
            </Card.Body>
          </Card>
        </Col>
      </Modal>

      <Modal
        size="lg"
        show={modalExport}
        onHide={() => {
          setModalExport(false);
          handleExportPengajuan();
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title
                        as="h4"
                        style={{ fontWeight: "bold", textTransform: "none" }}
                      >
                        Export Pengajuan
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Tanggal Awal
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAwal(e.target.value);
                            }}
                            type="date"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Tanggal Akhir
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAkhir(e.target.value);
                            }}
                            type="date"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Status
                          </label>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="singleStatus"
                            onChange={(value) => setStatus(value)}
                            options={[
                              {
                                value: "",
                                label: "Pilih Status",
                                isDisabled: true,
                              },
                              {
                                value: "Disetujui",
                                label: "Disetujui",
                              },
                            ]}
                            placeholder="Pilih Status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="submit"
                      variant="info"
                      onClick={submitExport}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Container
        fluid
        style={{
          padding: "15px",
          backgroundColor: "#F0F2F5",
          minHeight: "100vh",
        }}
      >
        {/* SECTION 1: HEADER & PERIOD FILTER */}
        <Row className="mb-4">
          <Col xl="12">
            <Card
              style={{
                border: "none",
                borderRadius: "24px",
                background: "linear-gradient(to top, #4c2d43, #ff001e)",
                color: "white",
                boxShadow: "0 15px 35px rgba(46, 49, 146, 0.2)",
                overflow: "visible",
                minHeight: "350px",
              }}
            >
              <Card.Body className="p-0">
                <Row
                  className="no-gutters align-items-stretch"
                  style={{ minHeight: "350px" }}
                >
                  <Col
                    md="9"
                    className="p-4 d-flex flex-column justify-content-center"
                  >
                    <Row className="align-items-center mb-4">
                      <Col sm="8" className="d-flex align-items-center">
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "15px",
                            borderRadius: "20px",
                            marginRight: "25px",
                            boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
                            width: "200px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <img
                            alt="Logo BPR Jatim"
                            src={require("assets/img/bprJatimLogo.png").default}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                        <div>
                          <h5
                            className="m-0 font-weight-bold"
                            style={{
                              fontSize: "16px",
                              letterSpacing: "2px",
                              color: "#ffd700",
                            }}
                          >
                            PERFORMANCE MONITOR
                          </h5>
                          <h2
                            className="m-0 font-weight-bold"
                            style={{ fontSize: "2.8rem", lineHeight: "1.1" }}
                          >
                            BPR JATIM
                          </h2>
                        </div>
                      </Col>
                      <Col sm="4" className="text-sm-right">
                        <p
                          className="mb-0 text-uppercase font-weight-bold"
                          style={{
                            fontSize: "1rem",
                            color: "#e0e0e0",
                            fontWeight: "bolder",
                          }}
                        >
                          Total Achievement
                        </p>
                        <h1
                          className="m-0 font-weight-bold"
                          style={{
                            // Angka persentase pakai warna Putih agar "pop out" di atas merah-ungu
                            color: "#FFFFFF",
                            fontSize: "5rem",
                            lineHeight: "1",
                            textShadow: "2px 4px 10px rgba(0,0,0,0.2)",
                          }}
                        >
                          {hasilPresentase}%
                        </h1>
                      </Col>
                    </Row>
                    <div
                      className="bg-white text-dark p-4"
                      style={{
                        borderRadius: "18px",
                        boxShadow: "inset 0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Row className="text-center align-items-center no-gutters">
                        <Col md="6" className="border-right px-2">
                          <small className="text-muted font-weight-bold d-block mb-2">
                            TOTAL REALISASI
                          </small>
                          <span
                            className="font-weight-bold"
                            style={{ fontSize: "18px", color: "#2e3192" }}
                          >
                            {formatRupiah(totalNominalPencairan)}
                          </span>
                        </Col>
                        <Col md="6" className=" px-2">
                          <small className="text-muted font-weight-bold d-block mb-2">
                            TARGET NOMINAL
                          </small>
                          <span
                            className="font-weight-bold text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            {formatRupiah(totalNominalTarget)}
                          </span>
                        </Col>
                        {/* <Col md="4" className="px-2">
                          <small className="text-danger font-weight-bold d-block mb-2">
                            GAP REALISASI
                          </small>
                          <span
                            className="font-weight-bold text-danger"
                            style={{ fontSize: "18px" }}
                          >
                            {formatRupiah(
                              totalNominalTarget - totalNominalPencairan,
                            )}
                          </span>
                        </Col> */}
                      </Row>
                    </div>
                  </Col>
                  <Col
                    md="3"
                    className="p-4 d-flex flex-column justify-content-center"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.25)",
                      borderRadius: "0 24px 24px 0",
                    }}
                  >
                    <Button
                      onClick={() => setModalExport(true)}
                      className="btn-block font-weight-bold mb-4 shadow-sm"
                      style={{
                        borderRadius: "12px",
                        backgroundColor: "#F5BF03",
                        border: "none",
                        color: "#1e293b",
                        padding: "10px",
                      }}
                    >
                      <i className="fas fa-file-excel mr-2"></i> EXPORT EXCEL
                    </Button>
                    <label
                      className="font-weight-bold mb-2 text-white-50"
                      style={{ fontSize: "12px" }}
                    >
                      DARI TANGGAL
                    </label>
                    <ReactDatetime
                      inputProps={{
                        className:
                          "form-control border-0 bg-white text-dark text-center mb-3",
                        style: {
                          borderRadius: "12px",
                          fontWeight: "900",
                          height: "50px",
                        },
                        readOnly: true,
                      }}
                      onChange={(e) =>
                        setDariTgl(e.toDate().setHours(0, 0, 0, 0))
                      }
                      value={dariTgl}
                      timeFormat={false}
                    />
                    <label
                      className="font-weight-bold mb-2 text-white-50"
                      style={{ fontSize: "12px" }}
                    >
                      SAMPAI TANGGAL
                    </label>
                    <ReactDatetime
                      inputProps={{
                        className:
                          "form-control border-0 bg-white text-dark text-center",
                        style: {
                          borderRadius: "12px",
                          fontWeight: "900",
                          height: "50px",
                        },
                        readOnly: true,
                      }}
                      onChange={(e) =>
                        setSmpTgl(e.toDate().setHours(23, 59, 0, 0))
                      }
                      value={smpTgl}
                      timeFormat={false}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* SECTION 2: SDM & STATUS GRID */}

        <Row className="mb-4 d-flex align-items-stretch">
          {/* KOLOM KIRI: INFORMASI SDM */}
          <Col xl="3" lg="4" md="12" className="mb-3 mb-lg-0">
            <Card
              style={{
                border: "none",
                borderRadius: "24px",
                height: "100%", // Ini akan memaksa Card mengikuti tinggi Row
                boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="p-3 border-bottom d-flex align-items-center justify-content-between">
                <h6
                  className="m-0 font-weight-bold text-muted"
                  style={{ fontSize: "12px", letterSpacing: "1px" }}
                >
                  INFORMASI SDM
                </h6>
                <i
                  className="fas fa-info-circle text-muted"
                  style={{ opacity: 0.5 }}
                ></i>
              </div>

              <Card.Body className="p-3 d-flex flex-column justify-content-between">
                {[
                  {
                    label: "AREA MANAGER",
                    val: totalAM.totalAm,
                    color: "#2e3192",
                    icon: "user-tie",
                  },
                  {
                    label: "SUPERVISOR",
                    val: totalSpv.totalSpv,
                    color: "#f90203",
                    icon: "user-shield",
                  },
                  {
                    label: "MARKETING",
                    val: totalMarketing.totalSm,
                    color: "#2e3192",
                    icon: "users",
                  },
                  {
                    label: "CABANG",
                    val: totalCbg.totalCabang,
                    color: "#f90203",
                    icon: "building",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-center p-2"
                    style={{
                      backgroundColor: "#f8fafc",
                      borderRadius: "15px",
                      border: "1px solid #f1f5f9",
                      flex: "1", // Membuat setiap item SDM membagi rata tinggi yang tersedia
                      margin: "5px 0",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "10px",
                        backgroundColor: `${item.color}15`,
                        color: item.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "12px",
                        flexShrink: 0,
                      }}
                    >
                      <i
                        className={`fas fa-${item.icon}`}
                        style={{ fontSize: "16px" }}
                      ></i>
                    </div>
                    <div>
                      <small
                        className="text-muted d-block font-weight-bold"
                        style={{ fontSize: "11px" }}
                      >
                        {item.label}
                      </small>
                      <h5
                        className="m-0 font-weight-bold"
                        style={{ fontSize: "16px" }}
                      >
                        {item.val}{" "}
                        <small
                          className="text-muted"
                          style={{ fontSize: "11px", fontWeight: "bold" }}
                        >
                          Unit/Orang
                        </small>
                      </h5>
                    </div>
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>

          {/* KOLOM KANAN: STATUS GRID */}
          <Col xl="9" lg="8" md="12">
            <Row className="h-100" style={{ margin: "-8px" }}>
              {[
                {
                  label: "Menunggu",
                  val: tampilTotalPengajuan.menunggu,
                  color: "#FFAF05",
                  icon: "clock",
                },
                {
                  label: "Revisi",
                  val: tampilTotalPengajuan.revisi,
                  color: "#fc556e",
                  icon: "edit",
                },
                {
                  label: "Diproses",
                  val: tampilTotalPengajuan.proses,
                  color: "#2e3192",
                  icon: "sync",
                },
                {
                  label: "Disetujui",
                  val: tampilTotalPengajuan.disetujui,
                  color: "#5AC967",
                  icon: "check-circle",
                },
                {
                  label: "Ditolak",
                  val: tampilTotalPengajuan.ditolak,
                  color: "#f90203",
                  icon: "times-circle",
                },
              ].map((item, idx) => (
                <Col xl="4" md="6" sm="6" xs="12" key={idx} className="p-2">
                  <Card
                    style={{
                      border: "none",
                      borderRadius: "20px",
                      height: "100%",
                      // Menghapus minHeight agar card status benar-benar mengikuti grid barisnya
                      boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                      borderLeft: `8px solid ${item.color}`,
                      background: "#fff",
                      margin: 0,
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-3">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h6
                            className="text-muted font-weight-bold text-uppercase mb-1"
                            style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                          >
                            {item.label}
                          </h6>
                          <h2
                            className="font-weight-bold m-0"
                            style={{ color: "#1e293b", fontSize: "2.2rem" }}
                          >
                            {item.val || 0}
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#94a3b8",
                                marginLeft: "8px",
                                fontWeight: "900",
                              }}
                            >
                              Berkas
                            </span>
                          </h2>
                        </div>
                        <div
                          style={{
                            backgroundColor: `${item.color}15`,
                            color: item.color,
                            padding: "10px",
                            borderRadius: "10px",
                          }}
                        >
                          <i className={`fas fa-${item.icon} fa-md`}></i>
                        </div>
                      </div>

                      <div
                        className="pt-2 mt-2 border-top"
                        style={{ borderColor: "#f1f5f9" }}
                      >
                        <small
                          className="text-muted"
                          style={{ fontSize: "13px", fontWeight: "bold" }}
                        >
                          <i className="fas fa-history mr-1"></i> Terakhir
                          diperbarui
                        </small>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <div className="container-fluid">
          {/* STYLE UNTUK ANIMASI & HOVER */}
          <style>{`
    .fade-in-chart { animation: fadeIn 0.8s ease-in-out; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    .chart-card { border: none; border-radius: 24px; box-shadow: 0 20px 45px rgba(30, 41, 59, 0.05); transition: all 0.3s ease; background: white; }
    .chart-card:hover { transform: translateY(-5px); box-shadow: 0 25px 50px rgba(30, 41, 59, 0.1); }
  `}</style>

          {/* GRAFIK 1: ANALISIS PERFORMA CABANG */}
          <Row className="mt-4">
            <Col md="12">
              <Card className="chart-card">
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex align-items-center mb-1">
                        <div
                          style={{
                            width: "12px",
                            height: "24px",
                            backgroundColor: "#2e3192",
                            borderRadius: "4px",
                            marginRight: "10px",
                          }}
                        ></div>
                        <h4
                          className="m-0 font-weight-bold"
                          style={{ color: "#1e293b", letterSpacing: "-0.5px" }}
                        >
                          Analisis Performa Cabang
                        </h4>
                      </div>
                      <small className="text-muted font-weight-bold ml-3">
                        Monitoring Realisasi vs Target per Kantor Cabang
                      </small>
                    </div>
                    <Button
                      onClick={() => setModalDetail(!modalDetail)}
                      style={{
                        backgroundColor: "#f1f5f9",
                        color: "#2e3192",
                        border: "none",
                        fontWeight: "800",
                        borderRadius: "12px",
                        fontSize: "12px",
                      }}
                      className="px-4 py-2 shadow-none"
                    >
                      <i className="fas fa-expand-alt mr-2"></i> EXPLORE DETAIL
                    </Button>
                  </div>
                </Card.Header>

                <Card.Body className="px-4 pb-4">
                  {!chartData || !chartData.series ? (
                    <div className="text-center p-5">
                      <h5>Memuat Data Grafik...</h5>
                    </div>
                  ) : (
                    <div className="fade-in-chart">
                      {/* LEGEND */}
                      <div
                        className="d-flex flex-wrap justify-content-center mb-4 py-2"
                        style={{
                          backgroundColor: "#f8fafc",
                          borderRadius: "16px",
                          border: "1px solid #f1f5f9",
                        }}
                      >
                        {[
                          { label: "Target Cabang", color: "#2e3192" },
                          { label: "Total Realisasi", color: "#f90203" },
                        ].map((item, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center mx-3 my-1"
                          >
                            <div
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "4px",
                                backgroundColor: item.color,
                                marginRight: 8,
                              }}
                            ></div>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#475569",
                              }}
                            >
                              {item.label}
                            </span>
                          </div>
                        ))}
                      </div>

                      <VictoryChart
                        height={320}
                        width={900}
                        domainPadding={{ x: 40 }}
                        /* FIX: Paksa sumbu Y mulai dari 0, jika data kosong set ke 0-1 */
                        domain={
                          chartData.series.some((s) => s.some((v) => v > 0))
                            ? undefined
                            : { y: [0, 1] }
                        }
                      >
                        <VictoryAxis
                          style={{
                            axis: { stroke: "#e2e8f0" },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Indeks Kantor Cabang"
                        />
                        <VictoryAxis
                          dependentAxis
                          style={{
                            axis: { stroke: "none" },
                            grid: {
                              stroke: "#f1f5f9",
                              strokeDasharray: "5, 5",
                            },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Nominal Pencairan (Miliar)"
                        />

                        <VictoryGroup offset={14}>
                          {[0, 1].map((seriesIdx) => (
                            <VictoryBar
                              key={seriesIdx}
                              data={
                                chartData.series[seriesIdx]?.map(
                                  (val, idx) => ({
                                    x: chartData.labels[idx],
                                    y: val / 1000000000,
                                    label: `${(val / 1000000000).toFixed(1)}M`,
                                  }),
                                ) || []
                              }
                              barWidth={10}
                              style={{
                                data: {
                                  fill: seriesIdx === 0 ? "#2e3192" : "#f90203",
                                },
                              }}
                              cornerRadius={{ top: 6 }}
                              labelComponent={
                                <VictoryTooltip
                                  flyoutStyle={{
                                    fill: "#1e293b",
                                    strokeWidth: 0,
                                  }}
                                  style={{ fill: "white", fontSize: 10 }}
                                />
                              }
                            />
                          ))}
                        </VictoryGroup>
                      </VictoryChart>

                      {/* INDEKS CABANG */}
                      <div
                        className="mt-4 p-3"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                          borderRadius: "24px",
                          border: "1px solid #f1f5f9",
                        }}
                      >
                        <Row>
                          {dataGrafikCabang &&
                            dataGrafikCabang.map((cabang, index) => (
                              <Col
                                lg="3"
                                md="4"
                                sm="6"
                                key={index}
                                className="mb-2"
                              >
                                <div
                                  className="d-flex align-items-center p-2 bg-white"
                                  style={{
                                    borderRadius: "14px",
                                    border: "1px solid #f1f5f9",
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-center mr-3 font-weight-bold"
                                    style={{
                                      minWidth: "30px",
                                      height: "30px",
                                      background:
                                        "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
                                      color: "white",
                                      borderRadius: "10px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {String.fromCharCode(65 + index)}
                                  </div>
                                  <span
                                    className="text-dark font-weight-bold text-truncate"
                                    style={{ fontSize: "11px" }}
                                  >
                                    {cabang.nama}
                                  </span>
                                </div>
                              </Col>
                            ))}
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* GRAFIK 2: PERFORMA INDIVIDU */}
          <Row className="mt-5 pb-5">
            <Col md="12">
              <Card
                className="chart-card"
                style={{
                  background:
                    "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                }}
              >
                <Card.Header className="bg-transparent border-0 pt-4 px-4 d-flex justify-content-between align-items-center flex-wrap">
                  <div className="d-flex align-items-center">
                    <div
                      className="p-3 mr-3"
                      style={{
                        borderRadius: "16px",
                        backgroundColor: "#f90203",
                        boxShadow: "0 8px 20px rgba(249, 2, 3, 0.2)",
                      }}
                    >
                      <i className="fas fa-user-tie text-white"></i>
                    </div>
                    <div>
                      <h4 className="m-0 font-weight-bold text-dark">
                        Performa Individu: {auth.nama}
                      </h4>
                      <small className="text-muted font-weight-bold">
                        Tinjauan Pencairan Bulanan Tahun {tahun}
                      </small>
                    </div>
                  </div>
                  <div style={{ width: "160px" }}>
                    <Select
                      className="react-select primary"
                      defaultValue={{ label: yearNow, value: yearNow }}
                      onChange={(value) => setTahun(value.value)}
                      options={listYear}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "14px",
                          fontWeight: "bold",
                          border: "2px solid #f1f5f9",
                        }),
                      }}
                    />
                  </div>
                </Card.Header>

                <Card.Body className="px-4">
                  {!chartDataUser || !chartDataUser.series ? (
                    <div className="text-center p-5">
                      <h5>Memuat Data Individu...</h5>
                    </div>
                  ) : (
                    <div className="fade-in-chart">
                      <div className="d-flex flex-wrap justify-content-center mb-4 py-2">
                        {[
                          { label: "Pencairan User", color: "#f90203" },
                          { label: "Target User", color: "#2e3192" },
                        ].map((item, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center mx-3"
                          >
                            <div
                              style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: item.color,
                                marginRight: 6,
                              }}
                            ></div>
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "800",
                                color: "#64748b",
                                textTransform: "uppercase",
                              }}
                            >
                              {item.label}
                            </span>
                          </div>
                        ))}
                      </div>

                      <VictoryChart
                        height={300}
                        width={900}
                        domainPadding={{ x: 45 }}
                        /* FIX: Paksa sumbu Y mulai dari 0, jika data kosong set ke 0-1 */
                        domain={
                          chartDataUser.series.some((s) => s.some((v) => v > 0))
                            ? undefined
                            : { y: [0, 1] }
                        }
                      >
                        <VictoryAxis
                          style={{
                            axis: { stroke: "#e2e8f0" },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Bulan"
                        />
                        <VictoryAxis
                          dependentAxis
                          style={{
                            axis: { stroke: "none" },
                            grid: {
                              stroke: "#f1f5f9",
                              strokeDasharray: "5, 5",
                            },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Nominal Pencairan (Miliar)"
                        />
                        <VictoryGroup offset={15}>
                          {[0, 1].map((seriesIdx) => (
                            <VictoryBar
                              key={seriesIdx}
                              data={
                                chartDataUser.series[seriesIdx]?.map(
                                  (val, idx) => ({
                                    x: chartDataUser.labels[idx],
                                    y: val / 1000000000,
                                    label: `${(val / 1000000000).toFixed(1)}M`,
                                  }),
                                ) || []
                              }
                              barWidth={10}
                              cornerRadius={{ top: 5 }}
                              style={{
                                data: {
                                  fill: seriesIdx === 0 ? "#f90203" : "#2e3192",
                                },
                              }}
                              labelComponent={
                                <VictoryTooltip
                                  flyoutStyle={{ fill: "#1e293b" }}
                                  style={{ fill: "white", fontSize: 10 }}
                                />
                              }
                            />
                          ))}
                        </VictoryGroup>
                      </VictoryChart>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
        {/* CSS OVERRIDE UNTUK DATETIME PICKER */}
        <style>{`
    .rdtPicker { background: white !important; border: none !important; border-radius: 15px !important; box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important; color: #333 !important; padding: 10px !important; }
    .rdt th, .rdt td { color: #333 !important; font-weight: bold !important; }
    .rdtDay:hover { background: #2e3192 !important; color: white !important; border-radius: 8px; }
    .rdtActive { background: #f90203 !important; color: white !important; border-radius: 8px; }
  `}</style>
      </Container>
    </>
  );
}

export default DashboardUtama;
